import React from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';

import trackEvent from '../../utils/trackEvent';
import { BUNDLE_BUY_CTA_CLICK } from '../../constants/events';

import Classes from './BundleHero.scss';
import { PrimaryButton } from '@hz-design-system/web-ui';

const event = {
  eventAction: BUNDLE_BUY_CTA_CLICK,
};

const BundleHero = () => (
  <div>
    <div className={Classes.root}>
      <h1 className={Classes.heading}>
        <Trans i18nKey="purchaseBundle.hero.heading_part_1" tagName="span" />
        <Trans i18nKey="purchaseBundle.hero.heading_part_2" tagName="span" className={Classes.highlighted} />
      </h1>
      <div className={Classes.body}>
        <Trans i18nKey="purchaseBundle.hero.body" tagName="span" />
      </div>
      <div className={Classes.ctaWrap}>
        <PrimaryButton
          as="a"
          href="#hz-PurchaseBundle-bundles"
          onClick={() => trackEvent(event)}
          className="hz-Button--callToAction"
        >
          <Trans i18nKey="purchaseBundle.hero.ctaButton" tagName="span" />
        </PrimaryButton>
      </div>
    </div>
  </div>
);

export default BundleHero;
